type UniversalWidgetGroup = {
  fk_brand_id?: string | number | null;
  system_generated_group_id?: string | number | null;
  [key: string]: unknown;
};

type BrandLike = {
  id?: string | number | null;
};

type UniversalWidgetGroupResponse =
  | UniversalWidgetGroup[]
  | {
      groups?: UniversalWidgetGroup[];
    }
  | null
  | undefined;

export function getUniversalWidgetGroups(
  groupList: UniversalWidgetGroupResponse,
  selectedBrandId?: string | number | null
) {
  const groups = Array.isArray(groupList)
    ? groupList
    : Array.isArray(groupList?.groups)
      ? groupList.groups
      : [];

  return groups.filter((group) => {
    if (!selectedBrandId) return true;
    if (group.fk_brand_id == null || group.fk_brand_id === "") return true;

    return String(group.fk_brand_id) === String(selectedBrandId);
  });
}

export function isDominosBrand(
  selectedBrand: BrandLike | null | undefined,
  dominosBrandId?: string | number | null
) {
  const brandId = selectedBrand?.id;

  if (brandId == null || dominosBrandId == null || dominosBrandId === "") {
    return false;
  }

  return String(brandId) === String(dominosBrandId);
}

export function getFirstUniversalWidgetGroupId(
  groups: UniversalWidgetGroup[] | null | undefined
) {
  const groupId = groups?.[0]?.system_generated_group_id;
  return groupId == null ? "" : String(groupId);
}
